// extracted by mini-css-extract-plugin
module.exports =  {"root":"KYi7RgVO8mNqaLITNQOh","header":"p3XqhJtuk_kwoPlpBI_d"};